<template>
    <div class="container">
        <div class="content-box">
          <div class="element-wrapper pb-0">
            <h3 class="element-header">Depoimentos Dr.Achei</h3>
            <div class="element-box">
                <h5 class="form-header">Gerenciar Depoimentos do site Dr.Achei</h5>
                <div class="form-desc" style="margin-botton: 0;">Realize o cadastro, edição, publicação e remoção de publicação dos depoimentos cadastrados para o Dr.Achei.</div>
            </div>
          </div>
          
              <div class="element-wrapper">
                <div class="element-actions">
                  <a class="btn btn-warning" @click="novo">
                    <i class="fa fa-file"></i> <span>Novo</span>
                  </a>
                </div>
                <div class="element-box-tp">
                <div class="table-responsive">
                    <table class="table table-padded">
                      <thead>
                          <tr>
                            <th>Cliente</th>
                            <th style="width: 50%">Descrição</th>
                            <th>Status</th>
                            <th>
                            </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="depoimento in depoimentos" :key="depoimento._id">
                            <td>
                              <div class="user-with-avatar">
                                <img :alt="depoimento.nome" class="rounded-circle img-fluid" :src="depoimento.clienteImage" :onerror="`this.src='${urlError}'`">
                                <span>{{depoimento.nome}}</span>
                              </div>
                            </td>
                            <td>{{depoimento.descricao}}</td>
                            <td>{{depoimento.status}}</td>
                            <td class="row-actions text-center">
                                <a v-if="depoimento.status ==='EM_EDICAO'" style="cursor: pointer;" title="Publicar"
                                  @click="publicar(depoimento._id)">
                                  <i class="fa fa-upload"></i>
                                </a>
                                <a v-if="depoimento.status ==='PUBLICADO'" style="cursor: pointer;" title="Remover Publicação"
                                  @click="removerPublicacao(depoimento._id)">
                                  <i class="fa fa-unlink"></i>
                                </a>
                                <a v-if="depoimento.status ==='EM_EDICAO'" style="cursor: pointer;" title="Editar"
                                  @click="editar(depoimento)">
                                  <i class="fa fa-edit"></i>
                                </a>
                            </td>
                          </tr>
                      </tbody>
                    </table>
                </div>
                </div>
            </div>
          </div>
      
  <!-- Modal -->
  <div class="modal fade" id="modalDepoimento" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modelTitleId">Cadastro Depoimento Dr.Achei</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group" :class="{'has-danger': errors.has('nome')}">
                <label for="nome">Nome</label>
                <input type="text" class="form-control"
                  v-model="depoimento.nome"
                  id="nome" name="nome" v-validate="'required'">
                <div v-if="errors.has('nome')" class="help-block form-text text-muted form-control-feedback">
                  {{errors.first('nome')}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{'has-danger': errors.has('imageCliente')}">
                <label for="nome">Foto Cliente</label>
                <input type="file" class="form-control" accept="image/*"
                  @change="processFile($event)"
                  id="imageCliente" name="imageCliente">
              </div>
            </div>
            <div v-if="depoimentoImage" class="col-md6">
              <div class="form-group">
                <div class="user-with-avatar">
                  <img :alt="depoimento.nome" class="rounded-circle mx-auto d-block"
                    width="100px" height="100px" 
                    :src="depoimentoImage" :onerror="`this.src='${urlError}'`">
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group" :class="{'has-danger': errors.has('nome')}">
                <label for="descricao">Descrição</label>
                <textarea type="text" class="form-control"
                  v-model="depoimento.descricao"
                  id="descricao" name="descricao" v-validate="'required'">
                </textarea>
                <div v-if="errors.has('descricao')" class="help-block form-text text-muted form-control-feedback">
                  {{errors.first('descricao')}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
          <button @click="save" type="button" class="btn btn-primary">Salvar</button>
        </div>
      </div>
    </div>
  </div>

    </div>
</template>
<script>
import * as http from 'axios'

export default {
  data () {
    return {
      imagePreview: null,
      depoimentos: [],
      depoimento: {}
    }
  },
  async created () {
    this.listAll()
  },
  computed: {
    urlError () {
      return require('@/img/avatar1.jpg')
    },
    depoimentoImage () {
      if (this.imagePreview) {
        return this.imagePreview
      }
      if (this.depoimento.depoimentoImage) {
        return this.depoimento.depoimentoImage
      }
      return null
    }
  },
  methods: {
    async listAll () {
      const response = await http.get('/drAcheiDepoimentos')
      this.depoimentos = response.data
    },
    novo () {
      this.$validator.reset()
      this.depoimento = {}
      this.imagePreview = null
      this.$nextTick(() => {
        window.jQuery('#imageCliente').val('')
        window.jQuery('#modalDepoimento').modal('show')
      })
    },
    async publicar (id) {
      this.$store.dispatch('setLoading', true)
      await http.put(`/drAcheiDepoimentos/${id}/publicar`)
      this.$store.dispatch('setLoading', false)
      this.listAll()
    },
    async removerPublicacao (id) {
      this.$store.dispatch('setLoading', true)
      await http.put(`/drAcheiDepoimentos/${id}/removerPublicacao`)
      this.$store.dispatch('setLoading', false)
      this.listAll()
    },
    async editar (depoimento) {
      this.$store.dispatch('setLoading', true)
      this.depoimento = depoimento
      this.$store.dispatch('setLoading', false)

      this.$nextTick(() => {
        this.$validator.reset()
        window.jQuery('#modalDepoimento').modal('show')
      })
    },
    processFile (event) {
      this.depoimento.file = event.target.files[0]
      if (this.depoimento.file) {
        let file = new FileReader()
        const _self = this
        file.onload = (e) => {
          _self.imagePreview = e.target.result
        }
        file.readAsDataURL(this.depoimento.file)
      }
    },
    buidFormParam () {
      const params = new FormData()
      params.append('nome', this.depoimento.nome)
      params.append('descricao', this.depoimento.descricao)
      if (this.depoimento.file) {
        params.append('file', this.depoimento.file)
      } else {
        params.append('file', null)
      }
      return params
    },
    async save () {
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      this.$validator.validateAll()
        .then(async (result) => {
          if (result) {
            this.$store.dispatch('setLoading', true)
            if (this.depoimento._id) {
              await http.put(`/drAcheiDepoimentos/${this.depoimento._id}`, this.buidFormParam(), config)
            } else {
              await http.post('/drAcheiDepoimentos', this.buidFormParam(), config)
            }
            this.$store.dispatch('setLoading', false)
            this.listAll()
            this.$nextTick(() => {
              window.jQuery('#modalDepoimento').modal('hide')
            })
          }
        })
    },
    visualizar () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/drAcheiDepoimentos/DrAcheiDepoimento.vue